import config from '../../environment.json'
export default {
  AWSConfig: {
    Region: config[process.env.NODE_ENV].awsConfig.region,
    IdentityPoolId: config[process.env.NODE_ENV].awsConfig.identityPoolId,
    UserPoolId: config[process.env.NODE_ENV].awsConfig.userPoolId,
    ClientId: config[process.env.NODE_ENV].awsConfig.clientId,
    AccessKeyId: config[process.env.NODE_ENV].awsConfig.accessKeyId,
    SecretAccessKey: config[process.env.NODE_ENV].awsConfig.secretAccessKey,
  },

  AWSDriverConfig: {
    Region: 'us-east-1',
    IdentityPoolId: 'us-east-1:b3ff8253-9247-4480-921b-14725c74ad6d',
    UserPoolId: 'us-east-1_6Hs2QcqXd',
    ClientId: 'alsla0oh9n8vuf359gcuqltc8',
  },

  S3Config: {
    region: 'us-east-1',
    accessKeyId: 'AKIA6ODU5T5WJKDXG6UX',
    secretAccessKey: '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',
  },
}
